module.exports = __webpack_public_path__ + "img/userScale3.d1f7414e.png";